<cll-card class="app-card app-card-inset" *ngFor="let rate of _rateModels; trackBy: _trackFixedRateFn">
    <div class="form-row">
        <app-input-text
            class="flex-50"
            label="Name"
            data-testid="input:fixed-rate-name"
            [maxlength]="255"
            name="name"
            [(ngModel)]="rate.name"
            (ngModelChange)="_onModelChanged()"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [disabled]="disabled" />

        <app-input-currency
            class="flex-50"
            label="Amount"
            data-testid="input:fixed-rate-amount"
            name="amount"
            [(ngModel)]="rate.amount"
            (ngModelChange)="_onModelChanged()"
            [disabled]="disabled" />
    </div>

    <div *ngIf="rate.rules?.length">
        <hr class="app-separator">

        <app-contract-rules-list [(ngModel)]="rate.rules"
                                 (ngModelChange)="_onModelChanged()" />
    </div>

    <cll-card-footer>
        <div class="float-left">
            <app-input-checkbox
                class="app-fixed-rate-default"
                label="Default?"
                [disabled]="disabled"
                [(ngModel)]="rate.is_default"
                (ngModelChange)="onDefaultChanged(rate, $event)" />
        </div>

        <button cll-button (click)="addRule(rate)">
            <cll-icon>add</cll-icon>
            Add Rule
        </button>

        <button cll-outline-button
                colour="warn"
                (click)="deleteRate($event, rate)"
                title="Remove this rate"
                [disabled]="disabled"
                cllTooltip="Remove this fixed rate">
            <mat-icon>remove_circle_outline</mat-icon>
            Delete fixed rate
        </button>
    </cll-card-footer>
</cll-card>

<app-alert empty *ngIf="!_rateModels?.length">
    No fixed rates defined.

    <button app-alert-action
            cll-button
            data-testid="button:add-a-rate"
            title="Add a new rate"
            *ngIf="!disabled"
            (click)="addEmptyRate()">
        <mat-icon>add_circle_outline</mat-icon>

        Add a rate
    </button>
</app-alert>

<div *ngIf="!disabled && _rateModels?.length">
    <div class="align-center">
        <button cll-outline-button
                colour="variant"
                title="Add a new rate"
                (click)="addEmptyRate()">
            <mat-icon>add_circle_outline</mat-icon>

            Add a fixed rate
        </button>
    </div>
</div>

<p class="hint" *ngIf="hint">
    {{ hint }}
</p>
